export default __webpack_public_path__ + "static/media/NavLogoFooter_new.ba599d9b.svg";